<div class="tour-page">
  <div class="container-fluid tour-wrapper h-100" [ngStyle]="{background: state == 'info' || state == 'finished' ? '' : '#f1efef'}">
    <app-location-lottie-animation *ngIf="fetchLocation"></app-location-lottie-animation>
    <div class="row justify-content-left tour-position h-100">
      <div class=" px-0 tour-container">
        <nav @menu *ngIf="displayMenu" class="d-flex pb-4">
          <button (click)="toggleMenu(false)" class="py-3 px-4 mr-2 position-absolute">&#x2715;</button>
          <ul class="my-auto pb-5">
            <li>
              <a [routerLink]="" fragment="iOSInstructions" (click)="toggleMenu(false);">
                <ng-template [ngIf]="language == 'en'">Troubleshooting</ng-template>
                <ng-template [ngIf]="language == 'es'">Solución de problemas</ng-template>
              </a>
            </li>
            <li class="mt-2">
              <a href="http://www.sonomaplazahistory.com/donate/">
                <ng-template [ngIf]="language == 'en'">Donate</ng-template>
                <ng-template [ngIf]="language == 'es'">Donar</ng-template>
              </a>
            </li>
            <li class="mt-5 pt-2">
              <a href="http://www.sonomaplazahistory.com/">
                <b>
                  <ng-template [ngIf]="language == 'en'">Exit Tour</ng-template>
                  <ng-template [ngIf]="language == 'es'">Tour de salida</ng-template>
                </b>
              </a>
            </li>
          </ul>
        </nav>
  
        <div *ngIf="state != 'finished'" [ngStyle]="{background: state == 'info' || state == 'finished' ? '' : '#5b934e', filter: state == 'info' || state == 'finished' ? 'brightness(1) invert(1)' : ''}" class="container-fluid position-relative nav-top pt-4 pb-3">
          <div class="row">
            <button tabindex="1" (click)="toggleMenu(true)" class="py-0 px-0" aria-label="Open navigation menu"><img src="../../assets/menu.svg" alt="Navigation menu icon"></button>
            <div class="col-auto ml-auto my-auto pr-3">
              <a tabindex="2" href="http://sonomaplazahistory.com" target="_blank" rel="noopener noreferrer" aria-label="Sonoma Plaza History website link"><img class="logo" src="../../assets/logoCityHall.svg" alt="Sonom Plaza History logo"></a>
            </div>
          </div>
        </div>
  
        <div *ngIf="state != 'finished'" class="container-fluid tour-container">
          <div class="row banner" *ngIf="state == 'info' || state == 'finished'" [class.banner-info]="state == 'info' || state == 'finished'">
            <div class="col-12 px-0 h-100">
              <img *matches="'desktop'" [src]="'../../assets/banners/desktop/banner'+(stopNumber+1)+'.png'" class="w-100 banner-img">
              <img *matches="'mobile'" [src]="'../../assets/banners/mobile/banner'+(stopNumber+1)+'.png'" class="w-100 banner-img">
              <div class="opacity"></div>
            </div>
          </div>
  
          <!-- <div class="row banner-instruction overflow-hidden" [ngClass]="{'height-0 v-hidden': state == 'info' || state == 'finished'}">
            <div class="col-12 my-auto pl-4">
              <h1 class="my-0">{{ banner[stopNumber][0] }}</h1>
            </div>
          </div> -->
  
          <!-- <div class="row banner-title overflow-hidden" [ngClass]="{'height-0 v-hidden': state == 'info' || state == 'finished'}">
            <div class="col-12 my-auto pl-4">
              <p class="my-0">{{ banner[stopNumber][1] }}</p>
            </div>
          </div> -->
  
          <!-- <button class="help-btn py-3 px-3" [class.display-help-btn]="displayHelpBtn" (click)="toggleHelp(true)">?</button>
          <div class="container-fluid help-container" [class.show-help-container]="displayHelp">
            <div class="row justify-content-center">
              <div class="col-8 py-4">
                <button class="float-right" (click)="toggleHelp(false)">&#x2715;</button>
                <h1>Need help?</h1>
                <p>Choose force arrive if the map does not automatically load the next stop upon reaching the destination.</p>
                <button (click)="hasArrived(true)" class="force-arrive2 py-2 px-3">Force Arrive</button>
              </div>
            </div>
          </div> -->
  
          <!-- <div class="container-fluid help-container px-2" [class.display-help-btn]="displayHelpBtn">
            <div class="row justify-content-center help mx-0 py-2">
              <div class="col-1 my-auto pl-4 pr-1">
                <img src="../../assets/information-icon.svg">
              </div>
              <div class="col my-auto pr-0">
                <p *ngIf="language == 'en'" class="sm mb-0">When you’re within range of your destination, choose I’ve arrived.</p>
                <p *ngIf="language == 'es'" class="sm mb-0">Escoge “He llegado” si el destino no carga automáticamente</p>
              </div>
              <div class="col-auto my-auto">
                <button class="px-3 py-2" (click)="hasArrived(true)">
                  <u *ngIf="language == 'en'">I've arrived</u>
                  <u *ngIf="language == 'es'">He llegado</u>
                </button>
              </div>
            </div>
          </div> -->
          <app-map *ngIf="stops.length > 0"
            class="row overflow-hidden"
            (trackUserLocation)="fetchUserLocation($event)"
            [class.height-0]="state == 'info' || state == 'finished'"
            [state]="state"
            [stopNumber]="stopNumber"
            [stops]="stops"
            [language]="language"
            (location)="location($event)"
            (arrived)="hasArrived($event)">
          </app-map>
          <app-info
            *ngIf="state == 'info'"
            @infoAnimate
            class="row justify-content-center position-relative d-block"
            [ngClass]="{'overflow-hidden': overflowHidden}"
            [stopNumber]="stopNumber"
            [narration]="narrations[stopNumber]"
            [audioHidden]="audioHidden"
            [info]="infos[stopNumber]"
            [language]="language"
            (instruction)="instructionOff($event)"
            (changeState)="changeStateFromInfo($event)"
          ></app-info>
        </div>
  
        <div *ngIf="state == 'finished'" @finished class="container-fluid finish position-relative overflow-hidden">
          <div class="row justify-content-center h-100">
            <div class="col-12 text-center top">
              <a href="http://sonomaplazahistory.com" target="_blank" rel="noopener noreferrer">
                <img src="../../assets/city-hall.png" alt="Sonoma City Hall graphic">
              </a>
              <h3 class="text-center">Thank You!</h3>
            </div>
            <div class="bottom col-12 text-center pb-5">
              <div class="curve"></div>
              <h3 class="position-relative mb-0">Exit</h3>
              <p class="position-relative">Click to continue</p>
              <a class="d-block" href="http://sonomaplazahistory.com"><button class="position-relative"><img src="../../assets/next-arrow.svg"></button></a>
            </div>
          </div>
        </div>
  
        <div
          *ngIf="state == 'arrived'"
          class="arrived-container"
          @arrived>
          <div class="arrived">
            <div class="ratio"></div>
            <div class="blob container-fluid">
              <div class="row h-100">
                <div class="col-12 my-auto text-center pt-5">
                  <img class="walking mb-4" src="../../assets/walking.svg">
                  <h1 *ngIf="language == 'en'">You've Arrived!</h1>
                  <h1 *ngIf="language == 'es'">¡Has llegado!</h1>
                  <p class="mt-4"><b>{{ 'loadingStop.loadingTour' | translate }}</b></p>
                  <p *ngIf="language == 'es'" class="mt-4"><b>He llegado</b></p>
                  <a class="d-block mt-4 pt-3"><button (click)="changeState()"><img src="../../assets/next-arrow.svg"></button></a>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      </div>
      
      <div class="col-12 col-md-4 col-lg-4 col-xl-4 px-0 stopCard">
        <div *ngIf="!fetchLocation" class="card tour-stop-card" [ngClass]="{'height-0 d-none': state == 'info' || state == 'finished'}">
          <img *matches="'desktop'" [src]="'../../assets/banners/desktop/banner'+(stopNumber+1)+'.png'" class="w-100 banner-img">
          <img *matches="'mobile'" [src]="'../../assets/banners/mobile/banner'+(stopNumber+1)+'.png'" class="w-100 banner-img">
          <div class="card-content d-flex flex-column">
            <h5>{{ 'stopCard.nextStop' | translate }}</h5>
            <h2>{{ banner[stopNumber][0] }}</h2>
            <h6>{{ banner[stopNumber][1] }}</h6>
            <button *matches="'desktop'" type="button" (click)="hasArrived(true)"><img src="../../assets/location.svg" alt="">{{ 'stopCard.continueButton' | translate }}</button>
            <button *matches="'mobile'" type="button" (click)="hasArrived(true)"><img src="../../assets/location.svg" alt="">{{ 'stopCard.arrivedButton' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  